module.exports = __webpack_public_path__ + "img/triton-search-small.e4bb0460.png";